import React from "react";
import Youtube from "./Youtube";
import classes from "./YoutubeList.module.css";

const YoutubeList = (props) => {
  return (
    <ul className={classes["movies-list"]}>
      {props.movies.map((movie) => (
        <Youtube
          key={movie.id}
          id={movie.id}
          naam={movie.naam}
          titel={movie.titel}
          src={movie.src}
          width={movie.width}
          height={movie.height}
        />
      ))}
    </ul>
  );
};

export default YoutubeList;